<!-- filter.component.html -->
<div class="main-container">
    <div class="wrapper">
        <ng-container *ngTemplateOutlet="matchFilter"></ng-container>

        <!-- Dynamic filter conditions -->
        <ng-container *ngFor="let condition of filterConditions; let i = index; trackBy: trackByConditionIndex">
            <app-filter-condition-bar 
                [fieldDocuments]="fieldDocuments" 
                [fieldGroups]="fieldGroups"
                [filterCondition]="condition" 
                [conditionId]="i" 
                [allUsers]="allUsers"
                (conditionUpdated)="onConditionUpdated(i, $event)"
                (onRemove)="removeCondition(i)"
                (onInvalidationChange)="onConditionInvalidationChanged(i, $event)">
            </app-filter-condition-bar>

            <!-- Show logic operator between conditions (except after last condition) -->
            <ng-container *ngIf="i < filterConditions.length - 1">
                <div class="logic-container">
                    <div class="ym-my-3 ym-ml-5 ym-pl-1 ym-display-block">
                        {{selectedLogicOperator}}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- Add condition button -->
        <div class="action ym-display-flex ym-mt-6" [class.no-condition]="filterConditions.length === 0">
            <ym-button 
                [type]="buttonTypes.PRIMARY" 
                [icon]="iconNames.PLUS" 
                [variant]="buttonVariants.ICON_ONLY"
                (onClick)="addCondition()">
            </ym-button>
            <ym-button 
                [type]="buttonTypes.GHOST_LINK" 
                (onClick)="addCondition()">
                Add condition
            </ym-button>
        </div>
    </div>
</div>

<ng-template #matchFilter>
    <div class="match-filter-container ym-display-flex ym-justify-content-end ym-mb-3"
        *ngIf="filterConditions.length > 0">
        <ym-button-group [size]="buttonGroupSize.SM" class="">
            <ym-button-group-item 
                [selected]="selectedLogicOperator === logicOperators.AND"
                (onClick)="onLogicOperatorChanged(logicOperators.AND)">
                Match all filters (and)
            </ym-button-group-item>
            <ym-button-group-item 
                [selected]="selectedLogicOperator === logicOperators.OR"
                (onClick)="onLogicOperatorChanged(logicOperators.OR)">
                Match any filters (or)
            </ym-button-group-item>
        </ym-button-group>
    </div>
</ng-template>